var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9865 35.0005C51.9865 34.6551 51.8072 34.3362 51.5151 34.1569L48.062 32.0245L51.5217 29.8723C51.8139 29.6929 51.9932 29.3741 51.9932 29.0287C51.9932 28.6832 51.8139 28.3644 51.5283 28.185L35.5246 18.1544C35.1992 17.9485 34.7875 17.9485 34.4688 18.1544L18.465 28.185C18.1728 28.3644 18.0002 28.6899 18.0002 29.0287C18.0002 29.3741 18.1795 29.6929 18.4717 29.8723L21.9048 32.0113L18.465 34.1575C18.1728 34.3369 17.9935 34.6624 18.0002 35.0012C18.0068 35.3399 18.1795 35.6654 18.4717 35.8448L21.9048 37.9838L18.465 40.1294C18.1728 40.3087 18.0002 40.6276 18.0002 40.973C18.0002 41.3184 18.1795 41.6373 18.465 41.8166L34.4688 51.8472C34.6281 51.9469 34.8141 52 35 52C35.1859 52 35.3652 51.9469 35.5312 51.8472L51.535 41.8166C51.8272 41.6306 52.0065 41.3118 51.9998 40.9664C51.9932 40.6209 51.8205 40.3021 51.5283 40.1227L48.0753 37.9904L51.535 35.8382C51.8139 35.6648 51.9932 35.3459 51.9865 35.0005ZM20.8689 29.022L34.9934 20.1672L49.1178 29.022C48.985 29.1084 35.3984 37.5646 34.9934 37.817L20.8689 29.022ZM49.1045 40.9856L34.9867 49.8338L20.8623 40.9856L23.7775 39.1655L34.4621 45.8149C34.6215 45.9146 34.8074 45.9677 34.9867 45.9677C35.166 45.9677 35.352 45.9146 35.5113 45.8149L46.1694 39.1788L49.1045 40.9856ZM34.9867 43.7955L20.8689 35.0005L23.7775 33.1804L34.4621 39.8298C34.6215 39.9294 34.8074 39.9826 34.9867 39.9826C35.166 39.9826 35.352 39.9294 35.5113 39.8298L46.1694 33.1937L49.0979 35.0005C49.0182 35.0603 35.3652 43.563 34.9867 43.7955Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.02de7d7e23b729fe49783a8835f37f68.svg";
export { ForwardRef as ReactComponent };